import React from 'react';
import cn from 'classnames/bind';

import SearchTable from '../../components/SearchTable/SearchTable';
import SearchTableHead from '../../components/SearchTableHead/SearchTableHead';
import SearchTableHeadCell from '../../components/SearchTableHeadCell/SearchTableHeadCell';
import DatepickerTableHeadCell from '../../components/DatepickerTableHeadCell/DatepickerTableHeadCell';
import SearchTableBody from '../../components/SearchTableBody/SearchTableBody';
import SearchTableBodyCell from '../../components/SearchTableBodyCell/SearchTableBodyCell';
import Sprite from '../../../../components/Sprite';

import styles from './LogsSearchTable.module.css';
import { convertDate } from '../../../../utils/helpers';

const cx = cn.bind(styles);

function LogsSearchTable(props) {
  function handleRowClick(id) {
    props.history.push(`/log/${id}`);
  }

  function handleOrderClick(name, values, actions) {
    if (values.orderBy === name) {
      actions.setFieldValue('orderBy', `-${name}`);
      props.onFilter({ ...values, orderBy: `-${name}` }, actions);
    } else {
      actions.setFieldValue('orderBy', name);
      props.onFilter({ ...values, orderBy: name }, actions);
    }
  }

  return (
    <section className={styles.wrapper}>
      <SearchTable>
        <SearchTableHead rowClassName={cx({ 'table-row': true })}>
          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="serialNumber"
            icon="magnifier"
            actions={props.actions}
          >
            Номер журнала
          </SearchTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="title"
            icon="magnifier"
            actions={props.actions}
          >
            Наименование
          </SearchTableHeadCell>

          <DatepickerTableHeadCell
            className={cx({ 'table-cell': true })}
            name="created"
            icon="calendar"
            actions={props.actions}
            value={props.values.created}
          >
            <button
              type="button"
              icon="magnifier"
              onClick={() => handleOrderClick('created', props.values, props.actions)}
              className={cx({ 'button-text': true })}
            >
              Дата создания
              <Sprite
                name="sort-arrow"
                role="img"
                className={cx({
                  arrow: true,
                  'arrow-ordered': props.values.orderBy === '-created',
                })}
              />
            </button>
          </DatepickerTableHeadCell>

          <DatepickerTableHeadCell
            className={cx({ 'table-cell': true })}
            name="modified"
            icon="calendar"
            actions={props.actions}
            value={props.values.modified}
          >
            Обновлено
          </DatepickerTableHeadCell>
        </SearchTableHead>

        <SearchTableBody results={props.logs.results.length}>
          {props.logs.results.map(({ id, serialNumber, title, created, modified }) => {
            created = convertDate(created, 'd.LL.yyyy');
            modified = convertDate(modified, 'd.LL.yyyy HH:mm');

            return (
              <tr
                key={id}
                onClick={() => handleRowClick(id)}
                className={cx({ 'table-row': true, 'table-body-row': true })}
              >
                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {serialNumber}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {title}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {created}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {modified}
                </SearchTableBodyCell>
              </tr>
            );
          })}
        </SearchTableBody>
      </SearchTable>

      <div className={styles.footer}>{props.children}</div>
    </section>
  );
}

export default LogsSearchTable;
